import React from 'react';
import { fileUpload } from '../../data/restWrapper';
import './style.css';
import { isFeatureEnabled } from '../FeatureFlag';
import translate from '@data/translations';

interface FileUploadProps {
    setFileUploading: Function;
    onFileUploaded?: Function;
    uploadButtonStyle?: string;
    uploadButtonText?: string;
    category?:string
    inputWrapperClass?:string
}

const FileUpload = (props: FileUploadProps) => {
    const { setFileUploading, onFileUploaded, uploadButtonStyle, uploadButtonText, category, inputWrapperClass} = props;
    const onChangeHandler = async (e: any) => {
        try {
            setFileUploading(true);
            let fileInfo = await fileUpload(`/uploadDocument/${category ? category :''}`, e.target.files[0]);
            if (onFileUploaded) {
                onFileUploaded(fileInfo);
            }        
            setFileUploading(false);
        } catch (err) {
            setFileUploading(false);
            console.warn(err);
        }
    };

    if (!isFeatureEnabled('fileUploads')) {
        return null;
    }

    let uploadButtonStyleDefault = uploadButtonStyle ? uploadButtonStyle : null;
    let uploadButtonTextDefault = uploadButtonText ? (
        uploadButtonText
    ) : (
        <span>
            <i className="fa fa-upload" aria-hidden="true"></i>
            {translate('Choose a file')}
        </span>
    );
    return (
        <React.Fragment>
            <div className={inputWrapperClass ? inputWrapperClass : ""}>
            <input
                id="file"
                className="inputfile-v-2"
                type="file"
                name="file"
                onChange={(e) => {
                    onChangeHandler(e);
                }}
            />
            <label className={uploadButtonStyleDefault + ' uppercase'} htmlFor="file">
                {uploadButtonTextDefault}
            </label>
            </div>
     
        </React.Fragment>
    );
};

export default FileUpload;
